import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchOttopay, exportFile } from 'actions/Ottopay'
import OttopayView from 'components/pages/ottopay/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'
// import { saveAs } from 'file-saver'
import { message } from 'antd'
import moment from 'moment'


export function mapStateToProps(state) {
  const {
    isFetching,
    dataOttopay,
    metaOttopay,
  } = state.root.ottopay

  return {
    isFetching,
    dataOttopay,
    metaOttopay,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchOttopay: bindActionCreators(fetchOttopay, dispatch),
  exportFile: bindActionCreators(exportFile, dispatch),
})

const dataLimit = [
  { id: 1, label: '10' },
  { id: 2, label: '15' },
  { id: 3, label: '25' },
  { id: 4, label: '50' },
  { id: 5, label: '100' },
]

const dataStatus = [
  { id: 1, value: 'draft', label: 'Draft' },
  { id: 2, value: 'confirmed', label: 'Confirmed' },
  { id: 3, value: 'settled', label: 'Settled' },
  { id: 4, value: 'in progress', label: 'In Progress' },
  { id: 4, value: 'failed', label: 'Failed' },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('limitList', 'setLimitList', dataLimit),
  withState('statusList', 'setStatusListn', dataStatus),
  withState('dataFile', 'setDataFile', ''),
  withState('paramsFile', 'setParamsFile', ''),
  withState('stateSearch', 'setStateSearch', {}),
  withState('isExport', 'setIsExport', false),
  withHandlers({
    onLoad: props => (isSearch) => {
      const {
        page, search, limit, status, date,
      } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
        status: status || '',
        limit: limit || '',
        date: date || '',
      }
      props.setParamsFile(`?${qs.stringify(pickBy(payload, identity))}`)
      props.fetchOttopay(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),
  withHandlers({
    handleReport: props => () => {
      const { paramsFile, setIsExport } = props
      setIsExport(true)
      props.exportFile(paramsFile)
        .then((result) => {
          if (result) {
            const FileSaver = require('file-saver') // eslint-disable-line global-require
            const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            FileSaver.saveAs(blob, `ottopay_report_${moment().format('DD_MM_YY')}.xlsx`)
            setIsExport(false)
          } else {
            message.error('Something when wrong')
          }
        }).catch(() => {
          message.error('Something when wrong')
          setIsExport(false)
        })
    },
    handleChangeDate: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      let getDate
      if (val.length === 2) {
        getDate = `${val[0].format('YYYY-MM-DD')},${val[1].format('YYYY-MM-DD')}`
      } else {
        getDate = ''
      }
      setStateSearch({
        ...stateSearch,
        date: getDate,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeStatus: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        status: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleLimit: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        limit: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleSearch: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        search: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Ottopay'])
      this.props.updateSiteConfigs({
        titlePage: 'Ottopay Transaction List',
        activePage: 'ottopay',
        activeSubPage: 'ottopay',
      })
      this.props.fetchOttopay()
    },
  }),
)(OttopayView)
